"use client";

import { useLocale, useTranslations } from "next-intl";
import { useRouter, usePathname } from "@/i18n/navigation";
import { useParams, useSearchParams } from "next/navigation";
import { useTransition } from "react";
import { Globe } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { locales, localeLabels, type Locale } from "@/i18n/routing";

export function LanguageSwitcher() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();
  const searchParams = useSearchParams();
  const [isPending, startTransition] = useTransition();
  const t = useTranslations("footer");

  const onChange = (nextLocale: string) => {
    startTransition(() => {
      // pathname from next-intl is the locale-stripped path; router.replace
      // adds the new locale prefix according to routing config.
      const qs = searchParams.toString();
      const target = qs ? `${pathname}?${qs}` : pathname;
      router.replace(
        // @ts-expect-error -- params type is loose
        { pathname: target, params },
        { locale: nextLocale as Locale },
      );
    });
  };

  return (
    <div className="flex items-center gap-2">
      <Globe className="w-4 h-4 text-muted-foreground" />
      <span className="sr-only">{t("languageLabel")}</span>
      <Select value={locale} onValueChange={onChange} disabled={isPending}>
        <SelectTrigger className="w-[160px] h-9 bg-transparent border-border text-sm">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {locales.map((l) => (
            <SelectItem key={l} value={l}>
              {localeLabels[l]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
